import { BankingOnboardingFragment } from 'generated/resources/graphql'

import { bankLogo, getContinueOnboardingUrl, getDefaultAlias } from 'modules/banking/utils'
import { mapStatusToClass, mapStatusToText, messageFromStatus } from 'modules/banking/utils'

import { AccountsPageCard } from 'modules/banking/components/AccountsPageCard'

interface AccountOnboardingCardProps {
  onboarding: BankingOnboardingFragment
}

export const AccountOnboardingCard = ({ onboarding }: AccountOnboardingCardProps) => {
  const url = getContinueOnboardingUrl(onboarding, [])
  const status = onboarding.status
  const legalEntityName = onboarding.legalEntity.legalName || ''
  const linkText = messageFromStatus(onboarding.status)

  return (
    <AccountsPageCard
      logo={bankLogo(onboarding, getDefaultAlias(onboarding.creationSource))}
      statusType={mapStatusToClass(status)}
      status={mapStatusToText(status)}
      title={getDefaultAlias(onboarding.creationSource)}
      description={legalEntityName}
      to={url}
      linkText={linkText}
    />
  )
}
